module.exports = __webpack_public_path__ + "img/jail.16d324d3.png";